import './functions/bxslider';
import AOS from 'aos';
//require('slick-carousel');
require('./polyfills/find-polyfill');

// Extend Jquery with simple toggleText function - used for More/Less buttons
$.fn.extend({
    toggleText: function(a, b){
        return this.text(this.text() == b ? a : b);
    }
});

// Extend jquery check if div is in viewport
$.fn.isOnScreen = function(){
    var win = $(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};


$(window).on('load', function () {
    $('body').addClass('loaded');
});

let scrollRef = 0;
  $(window).on("resize scroll", function () {
    // increase value up to 10, then refresh AOS
    scrollRef <= 10 ? scrollRef++ : AOS.refresh();
  });


$(document).ready(function () {

    AOS.init({
        duration:1000,
        offset:5,
        delay:10,
    });

    //Home Header Scroll Down
    $('#home-intro-scroll').on('click', function(){
        $('html,body').animate({
            scrollTop: $("#home-page-block").offset().top
        }, 1000);
    });



    //Mobile Menu
    $('.menu-toggle').click(function () {
        $(this).toggleClass('active');
        $('.menu-overlay').fadeToggle();
        $('a.target-burger').toggleClass('toggled');
        $('.mobile-menu').slideToggle();
        $('body').addClass('menu-open');
    });


    // Back to top function
    $('.back-to-top').on('click', function(){
        $('html,body').animate({
            scrollTop: 0
        }, 1000);
    });


    // MOBILE PRODUCT TECH CHECKBOX
    $('#show-tech-spec').click(function () {
        $('ul.tech-spec').toggleClass('hide');
    });

    // PRODUCT SINGLE DROPDOWNS
    $('.products-single .section-title').click(function () {
        if ($(this).next().hasClass("show")) {
            $($(this).removeClass('active'));
            $('.section-content').removeClass('show');
            $($(this).next().removeClass('show'));
            $($(this).next().slideUp());
        } else {
            $('.section-title').removeClass('active');
            $($(this).addClass('active'));
            $('.section-content').slideUp();
            $('.section-content').removeClass('show');
            $($(this).next().addClass('show'));
            $($(this).next().slideDown());
        }
    }); 


    // IMAGE ROTATOR
     var productSlider = $('.products-list').bxSlider({
        speed: 500,
        pause: 8000,
        mode: 'fade',
        infiniteLoop: false,
        touchEnabled: false,
        auto: false,
        pager: true,
        hideControlOnEnd: true,
        pagerType: 'short',
        pagerShortSeparator: ' of ',
        controls: true
    });


    // IMAGE ROTATOR
    //  var hpSlider = $('.what-we-offer-rotator').bxSlider({
    //     speed: 500,
    //     pause: 8000,
    //     mode: 'fade',
    //     maxSlides: (window.innerWidth <= 767) ? 1 : 5,
    //     moveSlides: 1,
    //     shrinkItems: true,
    //     infiniteLoop: true,
    //     auto: true,
    //     pager: true,
    //     controls: false
    // });


    // // IMAGE ROTATOR - MOB ONLY
    //  var hpSlider = $('.mobile-image-rotator').bxSlider({
    //     speed: 500,
    //     pause: 8000,
    //     mode: 'fade',
    //     maxSlides: (window.innerWidth <= 767) ? 1 : 5,
    //     moveSlides: 1,
    //     shrinkItems: true,
    //     infiniteLoop: true,
    //     auto: true,
    //     pager: true,
    //     controls: false
    // });


    // CONTACT FORM TEXTAREA AUTO GROW
    $("textarea").keyup(function(e) {
        while($(this).outerHeight() < this.scrollHeight + parseFloat($(this).css("borderTopWidth")) + parseFloat($(this).css("borderBottomWidth"))) {
            $(this).height($(this).height()+1);
        };
    });
  


     // HIDE CF7 FORM ON SEND
    if ($('.wpcf7').length) {
        var wpcf7Elm = document.querySelector( '.wpcf7' );

        wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
          $('.form-wrap').hide();
        }, false );
    }

});


// WEBPACK FOOTER //
// ./assets/js/main.js